var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconFullscreen = function SvgIconFullscreen(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.32 19.5v-1.68H7.352l3.75-3.75-1.172-1.172-3.75 3.75V13.68H4.5v5.82zm3.75-8.398 3.75-3.75v2.968h1.68V4.5h-5.82v1.68h2.968l-3.75 3.75z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconFullscreen);
export { ForwardRef as ReactComponent };